import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { DoctorDashboardComponent } from "./doctor-dashboard/doctor-dashboard.component";
import { DoctorHomeComponent } from './doctor-home/doctor-home.component';
import { AppointmentsComponent } from '../shared/appointments/appointments.component';
import { ScheduleComponent } from './../shared/schedule/schedule.component';
import { PatientaccountsComponent } from './accounts/patientaccounts/patientaccounts.component';
import { DoctoraccountsComponent } from './accounts/doctoraccounts/doctoraccounts.component';
import { DepartmentsComponent } from './departments/departments.component';
import { PatientsComponent } from '../shared/patients/patients.component';
import { PatientsSAdminComponent } from './patients-s-admin/patients-s-admin.component';
import { DmessageCenterComponent } from './../shared/dmessage-center/dmessage-center.component';
import { ComposeEmailComponent } from './../shared/compose-email/compose-email.component';
import { MailViewComponent } from './../shared/mail-view/mail-view.component';
import { DoctordataComponent } from './../shared/doctordata/doctordata.component';
import { ApprovalsComponent } from './PendingApprovals/approvals.component';
import { RegisteredComponent } from './registered/registered.component';
import { DoctorregistrationComponent } from './doctorregistration/doctorregistration.component';
import { TerminationComponent } from './termination/termination.component';
import { DprofileeditComponent } from './dprofileedit/dprofileedit.component';
import { CovidFeedbacksComponent } from './covid-feedbacks/covid-feedbacks.component';
import { ROLES, USER_TYPES } from 'src/app/constant/constant';
import { MedicalProfessionDashboardComponent } from '../shared/medical-profession-dashboard/medical-profession-dashboard.component';
import { PatientRefundComponent } from './accounts/patient-refund/patient-refund.component';
import { LookupSearchPComponent } from './lookup-screen/lookup-patients/lookup-search-p/lookup-search-p.component';
import { LookupListPComponent } from './lookup-screen/lookup-patients/lookup-list-p/lookup-list-p.component';
import { LookupDisplayPComponent } from './lookup-screen/lookup-patients/lookup-display-p/lookup-display-p.component';
import { LookupSearchDComponent } from './lookup-screen/lookup-doctors/lookup-search-d/lookup-search-d.component';
import { LookupListDComponent } from './lookup-screen/lookup-doctors/lookup-list-d/lookup-list-d.component';
import { LookupDisplayDComponent } from './lookup-screen/lookup-doctors/lookup-display-d/lookup-display-d.component';
import { DoctorAgreementComponent } from '../shared/doctor-agreement/doctor-agreement.component';
import { RefferalComponent } from './refferal/refferal.component';
import { EgdCouponsComponent } from './admin/egd-coupons/egd-coupons.component';
import { AppVersionsComponent } from './admin/app-versions/app-versions.component';
import { AuthEgdGuard } from '../../../guards/auth-egd.guard';

import { PatientviewComponent } from '../../shared/patient-view/patientview/patientview.component';
import { DoctorvideosectionComponent } from '../shared/doctorvideosection/doctorvideosection.component';
import { UserRoleAuthorizeGuard } from 'src/app/guards/user-role-authorize.guard';
import { NovspecialDoctordashboardComponent } from '../shared/novspecial-doctordashboard/novspecial-doctordashboard.component';
import { SharePatientProfileComponent } from './share-patient-profile/share-patient-profile.component';
import { ReturnUrlGuard } from 'src/app/guards/return-url.guard';
import { AnalyticsDashboardComponent } from './analytics-dashboard/analytics-dashboard.component';
import { MarketingDashboardComponent } from './marketing-dashboard/marketing-dashboard.component';
import { ProviderLicencesComponent } from './provider-licences/provider-licences.component';
import { AdminApiKeysComponent } from './admin-api-keys/admin-api-keys.component';
import { UpdateLogoComponent } from './update-logo/update-logo.component';
import { ApproveProviderComponent } from './approve-provider/approve-provider.component';
import { VerifyProviderGuard } from 'src/app/guards/verify-provider.guard';
import { ProviderCountriesComponent } from './provider-countries/provider-countries.component';
import { LicenseTransactionsComponent } from './license-transactions/license-transactions.component';
import { PriorityListComponent } from './priority-list/priority-list.component';
import { TranslateGuard } from 'src/app/guards/translate.guard';
import { ProviderTransactionsComponent } from './provider-transactions/provider-transactions.component';
import { ProviderAgreementComponent } from './provider-agreement/provider-agreement.component';
import { DoctorCertificatesComponent } from './doctor-certificates/doctor-certificates.component';
import { CertificatesComponent } from '../../medical-profession/doctors/certificates/certificates.component';
import { ApproveCertificateComponent } from './approve-certificate/approve-certificate.component';


const userTypes = USER_TYPES;

const routes: Routes = [
    {
        path: `:slug/${userTypes['DOCTOR']}`,
        canActivate: [UserRoleAuthorizeGuard],
        canActivateChild: [UserRoleAuthorizeGuard, AuthEgdGuard],
        component: MedicalProfessionDashboardComponent,
        data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["Admin"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
        children: [
            {
                path: 'dashboard',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctorHomeComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["Admin"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'doctordata',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctordataComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'certificates',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: CertificatesComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'appointments',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: AppointmentsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["Admin"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'priority-list',
                canActivate: [UserRoleAuthorizeGuard],
                component: PriorityListComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'license_plans',
                canActivate: [UserRoleAuthorizeGuard],
                component: ProviderLicencesComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'license_transactions',
                canActivate: [UserRoleAuthorizeGuard],
                component: LicenseTransactionsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'approve-provider',
                canActivate: [UserRoleAuthorizeGuard],
                component: ApproveProviderComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"]] },
            },
            {
                path: 'approve-certificate',
                canActivate: [UserRoleAuthorizeGuard],
                component: ApproveCertificateComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"]] },
            },
            {
                path: 'provider-countries',
                canActivate: [UserRoleAuthorizeGuard],
                component: ProviderCountriesComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"]] },
            },
            {
                path: 'provider-transactions',
                canActivate: [UserRoleAuthorizeGuard],
                component: ProviderTransactionsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"]] },
            },
            {
                path: 'api_keys',
                canActivate: [UserRoleAuthorizeGuard],
                component: AdminApiKeysComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'update-logo',
                canActivate: [UserRoleAuthorizeGuard],
                component: UpdateLogoComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'schedule',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ScheduleComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'accounts/patients',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PatientaccountsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'accounts/doctors',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctoraccountsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'analytics',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: AnalyticsDashboardComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"]] },
            },
            {
                path: 'marketing-analytics',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: MarketingDashboardComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"]] },
            },
            {
                path: 'departments',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DepartmentsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'doctor-videosection',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctorvideosectionComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["Admin"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'patients',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PatientsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"]] },
            },
            {
                path: 'doctor-certificates',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctorCertificatesComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"]] },
            },
            {
                path: 'patients-sadmin',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PatientsSAdminComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'message-center',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DmessageCenterComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'compose-email',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ComposeEmailComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'mailview/:user_guid/:message_id/:sent',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: MailViewComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'pendingApprovals',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ApprovalsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'registered',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: RegisteredComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'provider-agreement',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ProviderAgreementComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'dregistration',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctorregistrationComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'termination',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: TerminationComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'edit',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DprofileeditComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["Admin"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'dprofileedit/:user_guid',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DprofileeditComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            // Don't delete
            {
                path: 'patientProfile/:patient_guid/:token',
                component: SharePatientProfileComponent,
                canActivate: [ReturnUrlGuard,TranslateGuard],
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'feedback',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: CovidFeedbacksComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'accounts/patients/refund',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PatientRefundComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'lookup-search-p',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LookupSearchPComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'lookup-list-p',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LookupListPComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'lookup-display-p',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LookupDisplayPComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'lookup-search-d',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LookupSearchDComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'lookup-list-d',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LookupListDComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'lookup-display-d',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LookupDisplayDComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'Referral',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: RefferalComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'admin/coupons',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: EgdCouponsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'admin/app/versions',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: AppVersionsComponent,
                data: { role_type: "doctor", sub_role: [ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: 'appointments/patient-view/:patient_guid/:consultation_id',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PatientviewComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"], ROLES.SuperAdmin] },
            },
            {
                path: 'Free-Medical-Counseling',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: NovspecialDoctordashboardComponent,
                data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["Admin"], ROLES["SuperAdmin"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
            },
            {
                path: "license/transaction/checkout/:resultType",
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: LicenseTransactionsComponent,
                data: { role_type: "doctor", sub_role: [ROLES.SuperAdmin] },
            },
        ]
    },
    {
        path: `:slug/${userTypes['DOCTOR']}/agreement` ,
        canActivate: [UserRoleAuthorizeGuard],
        component: DoctorAgreementComponent,
        data: { role_type: "doctor", sub_role: [ROLES["Doctor"], ROLES["SuperAdmin_Doctor"], ROLES["Admin_Doctor"]] },
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DoctorRoutingModule { }
